import ProductStrip from '_components/ProductStrip';
import type { AlgonomyPlacement } from '@components/global/Recommendations/Loader';

export interface AlgonomyPlacementCarouselProps {
  placement?: AlgonomyPlacement;
  coOpBrand?: string | null;
}

// coOpBrand is accepted via AlgonomyPlacementCarouselProps, ready for the
// follow-up GA4 ticket — it is not yet used in any tracking call.
const AlgonomyPlacementCarousel = ({
  placement,
}: AlgonomyPlacementCarouselProps) => {
  if (!placement) return null;
  // Only ever rendered inside a CIP/CLP slice zone, which owns the spacing
  // between slices and sets the side gutters every other slice uses.
  return <ProductStrip placement={placement} inSliceZone />;
};

export default AlgonomyPlacementCarousel;
